import React from 'react';
import { HeartCrack } from 'lucide-react';
export function PainSection() {
  return <section className="w-full py-20 px-6 md:px-8 bg-[#E8E0F0]" style={{
    paddingTop: '50px',
    paddingBottom: '50px'
  }} data-id="element-235">
      <div className="max-w-3xl mx-auto" data-id="element-236">
        <div className="flex items-center gap-3 mb-6 text-rose-DEFAULT" data-id="element-237">
          <HeartCrack className="w-8 h-8" data-id="element-238" />
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text" data-id="element-239">
            Esto es para ti SI…
          </h2>
        </div>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-text/80" data-id="element-240">
          <p data-id="element-241">
            Eres mamá primeriza, millennial, hispanohablante en Estados Unidos…
            y el primer mes te cayó como un camión.
          </p>

          <p className="font-medium text-text" data-id="element-242">
            No porque no ames a tu bebé. Sino porque:
          </p>

          <ul className="space-y-4 pl-2" data-id="element-243">
            {[{
            emoji: '🧩',
            text: 'estás funcionando a pedazos'
          }, {
            emoji: '😴',
            text: 'duermes en bloques ridículos'
          }, {
            emoji: '🩹',
            text: 'tu cuerpo duele o se siente raro'
          }, {
            emoji: '🎢',
            text: "tu mente salta entre 'todo bien' y 'no puedo'"
          }, {
            emoji: '💔',
            text: "y encima te dices a ti misma: 'debería poder'."
          }].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-244">
                <span className="text-xl flex-shrink-0" aria-hidden="true" data-id="element-245">
                  {item.emoji}
                </span>
                <span data-id="element-246">{item.text}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}